<div class="container-fluid my-3">
  <ng-container *ngIf="!loading">
    <ng-container *ngFor="let record of records">
      <div class="line d-flex">
        <div class="d-flex align-items-center" style="border-right: 1px solid #aaa">
          <span class="date" [id]="'date_' + record.id">
            {{record.time | date : 'MM/dd/yy hh:mm:ss'}}
          </span>

          <span *ngIf="record.userId > 0" class="userId"> ({{record.userId}}) </span>

          <span class="name">
            <a href="?name={{ record.userName | encodeUriComponent }}">
              {{record.userName}}
            </a>
          </span>
        </div>

        <span class="result"> {{record.result}} </span>
      </div>
    </ng-container>

    <div style="text-align: center; font-size: 16px;" class="my-3">
      <a *ngIf="page > 0" (click)="newer()" href="javascript:void(0)">&laquo; Newer</a>

      &nbsp;
      <a *ngIf="hasMore" (click)="older()" href="javascript:void(0)">Older &raquo;</a>
    </div>

    <div class="row align-items-center">
      <div class="col-auto">Up to date:</div>
      <div class="col">
        <form class="datepicker">
          <div class="input-group d-flex align-items-center">
            <input
              class="form-control"
              name="dp"
              [(ngModel)]="datePickerModel"
              (ngModelChange)="filterByDate()"
              ngbDatepicker
              #datePicker="ngbDatepicker"
              (click)="datePicker.toggle()"
            />

            <a href="javascript:void(0)" class="ml-3" (click)="filterByDate()">Show</a>

            <a href="javascript:void(0)" (click)="clearFilter()" class="btn btn-default navbar-btn mb-0 ml-3">Clear</a>
          </div>
        </form>
      </div>
    </div>

  </ng-container>
</div>
